(function () {
  var root = document.querySelector('.ax-product');
  if (!root) return;

  var variantInput = root.querySelector('[data-variant-input]');
  var swatches = root.querySelectorAll('[data-variant-swatch]');
  var packshotImg = document.getElementById('ax-product-packshot');
  var packshotDataEl = document.getElementById('ax-packshot-data');
  var packshotData = {};
  if (packshotDataEl) {
    try { packshotData = JSON.parse(packshotDataEl.textContent); } catch (e) {}
  }
  var gallerySlot0 = document.getElementById('ax-gallery-slot-0');
  var gallerySlot1 = document.getElementById('ax-gallery-slot-1');
  var galleryDataEl = document.getElementById('ax-gallery-data');
  var galleryData = {};
  if (galleryDataEl) {
    try { galleryData = JSON.parse(galleryDataEl.textContent); } catch (e) {}
  }
  var priceEls = root.querySelectorAll('[data-product-price]');
  var selectedColorEl = root.querySelector('[data-selected-color]');
  var qtyInput = root.querySelector('[data-qty-input]');
  var qtyDecrease = root.querySelector('[data-qty-decrease]');
  var qtyIncrease = root.querySelector('[data-qty-increase]');
  var stickyTitle = root.querySelector('.ax-product__sticky-title');
  var stickyForm = root.querySelector('.ax-product__form');

  function selectVariant(variantId) {
    var activeSwatch = null;
    swatches.forEach(function (swatch) {
      var isMatch = swatch.getAttribute('data-variant-swatch') === variantId;
      swatch.classList.toggle('is-active', isMatch);
      if (isMatch) activeSwatch = swatch;
    });

    if (!activeSwatch) return;

    if (variantInput) variantInput.value = activeSwatch.getAttribute('data-variant-id') || variantId;
    priceEls.forEach(function (el) {
      el.textContent = activeSwatch.getAttribute('data-variant-price');
    });
    if (selectedColorEl) selectedColorEl.textContent = activeSwatch.getAttribute('data-variant-color');
    if (packshotImg && packshotData[variantId]) packshotImg.src = packshotData[variantId];

    var galleryImages = galleryData[variantId];
    if (galleryImages) {
      if (gallerySlot0 && galleryImages[0]) gallerySlot0.src = galleryImages[0];
      if (gallerySlot1) {
        if (galleryImages[1]) gallerySlot1.src = galleryImages[1];
        gallerySlot1.style.display = galleryImages[1] ? '' : 'none';
      }
    }
  }

  swatches.forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      selectVariant(swatch.getAttribute('data-variant-swatch'));
    });
  });

  var initialSwatch = root.querySelector('.ax-product__swatch.is-active');
  if (initialSwatch) selectVariant(initialSwatch.getAttribute('data-variant-swatch'));

  if (qtyDecrease && qtyInput) {
    qtyDecrease.addEventListener('click', function () {
      var value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      qtyInput.value = value;
    });
  }

  if (qtyIncrease && qtyInput) {
    qtyIncrease.addEventListener('click', function () {
      var value = Math.max(1, parseInt(qtyInput.value || '1', 10) + 1);
      qtyInput.value = value;
    });
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) || 1);
    });
  }

  var titleRow = root.querySelector('.ax-product__title-row');
  if (titleRow && stickyForm && stickyTitle && 'IntersectionObserver' in window) {
    var titleObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var reached = entry.boundingClientRect.top < window.innerHeight;
        stickyForm.classList.toggle('is-compact', reached);
      });
    }, { threshold: [0, 1] });
    titleObserver.observe(titleRow);
  }
}());

// Desktop: the buy box is sticky. When it is taller than the window (e.g. "Product Details" is open) a fixed
// `top: 24px` would hide its lower part, so let it scroll until its bottom edge meets the window's bottom edge.
(function () {
  var info = document.querySelector('.ax-product__info');
  if (!info) return;

  function update() {
    var top = Math.min(24, window.innerHeight - info.offsetHeight - 24);
    info.style.top = top + 'px';
  }

  update();
  window.addEventListener('resize', update);
  info.querySelectorAll('details').forEach(function (d) {
    d.addEventListener('toggle', update);
  });
  window.addEventListener('load', update);
}());
